import React from 'react'

import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import {
  CruiseItem,
  FlightItem,
  LETripItem,
  TourItem,
} from 'tripPlanner/types/tripItem'
import { getOfferPagePrefilledStateParams } from 'tripPlanner/utils'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/restoreCart'

interface Props {
  item: Extract<LETripItem, CruiseItem | TourItem | FlightItem>
  restoreCartUrl: string
}

const UNSUPPORTED_ERR_MESSAGE =
  'Tour V2 & New Cruises do not have bundled flights'

function BookTourFlight(props: Props) {
  const { item, restoreCartUrl } = props

  const { closeModal, goBack } = useModalCallbacks()

  let unbundledText: string
  let unbundledURL: string

  if (item.type === 'TOUR' || item.type === 'CRUISE') {
    if (item.savedItemData.offerType === 'tour') {
      const { searchParams, hash } = getOfferPagePrefilledStateParams(item, {
        scrollToOptions: true,
      })
      const queryString = searchParams.toString()
      const URLSuffix = queryString ? `?${queryString}` : ''

      unbundledText = 'No, book tour only'
      unbundledURL = `/offer/tour/${item.code}${URLSuffix}${hash}`
    } else {
      throw new Error(UNSUPPORTED_ERR_MESSAGE)
    }
  } else {
    const data = structuredClone(item.savedItemData)
    delete data.tourBundle

    unbundledText = 'No, book flights only'
    unbundledURL = buildStandaloneFlightSearchURL(data)
  }

  return (
    <>
      <ModalHeader
        title="Book tour and flights package?"
        onBackButtonClick={goBack}
        onCloseButtonClick={closeModal}
      />
      <ModalBody>
        <ModalContent>
          <BodyText variant="large" as="p">
            You've added this order as a tour and flights package.
          </BodyText>
          <BodyText variant="large" as="p">
            Do you want to book these items together?
          </BodyText>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Yes, book tour and flights',
          to: restoreCartUrl,
        }}
        secondaryActionProps={{
          children: unbundledText,
          to: unbundledURL,
        }}
      />
    </>
  )
}

export default BookTourFlight
